import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import forexMindLogo from '@/assets/forexmind-logo.png';

export default function SplashPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setFadeIn(true), 100);
    return () => clearTimeout(t);
  }, []);

  const handleStart = () => {
    localStorage.setItem('fm_has_seen_splash', '1');
    const target = (location.state as { from?: string } | null)?.from;
    navigate(target && target !== '/splash' ? target : '/', { replace: true });
  };

  const features = [
    {
      icon: 'ri-robot-2-line',
      title: 'AI 智能体量化交易',
      desc: '自然语言驱动 AI 智能体，无需编写代码即可部署交易策略',
    },
    {
      icon: 'ri-brain-line',
      title: '透明决策链路',
      desc: '每一笔交易均可追溯 AI 推理过程，Market / Macro / Risk 三维度审计',
    },
    {
      icon: 'ri-shield-check-line',
      title: '多重风控保障',
      desc: '杠杆上限、每日亏损限制、保证金监控、强制平仓保护',
    },
  ];

  return (
    <div
      className="min-h-screen flex flex-col items-center relative overflow-hidden"
      style={{
        background: '#FFFFFF',
        fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif',
      }}
    >
      {/* Background gradient blobs */}
      <div
        className="absolute top-[-80px] left-[-60px] w-64 h-64 rounded-full opacity-20"
        style={{ background: 'radial-gradient(circle, #6366f1 0%, transparent 70%)' }}
      />
      <div
        className="absolute bottom-[120px] right-[-40px] w-48 h-48 rounded-full opacity-15"
        style={{ background: 'radial-gradient(circle, #8b5cf6 0%, transparent 70%)' }}
      />

      {/* Safe area spacer */}
      <div style={{ paddingTop: 'max(env(safe-area-inset-top, 0px), 24px)' }} />

      {/* Logo + Brand */}
      <div
        className={`flex flex-col items-center mt-24 transition-all duration-700 ${
          fadeIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <img
          src={forexMindLogo}
          alt="ForexMind"
          className="w-24 h-24 object-contain mb-5"
          style={{ filter: 'drop-shadow(0 12px 28px rgba(15, 23, 42, 0.18))' }}
        />
        <h1
          className="font-bold tracking-tight"
          style={{
            fontSize: '32px',
            color: '#111827',
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
          }}
        >
          ForexMind
        </h1>
        <p
          className="mt-2 text-center"
          style={{
            fontSize: '15px',
            color: '#9CA3AF',
            fontWeight: 400,
            letterSpacing: '0.01em',
          }}
        >
          AI 外汇量化交易决策平台
        </p>
      </div>

      {/* Features */}
      <div
        className={`w-full px-6 mt-12 flex flex-col gap-3 transition-all duration-700 delay-200 ${
          fadeIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        {features.map((f, i) => (
          <div
            key={f.title}
            className="flex items-start gap-3 bg-white rounded-2xl p-4"
            style={{
              boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
              border: '1px solid #F3F4F6',
            }}
          >
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ background: '#F5F3FF' }}
            >
              <i className={`${f.icon} text-lg`} style={{ color: '#6366f1' }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-gray-900 font-semibold text-sm">{f.title}</p>
              <p className="text-gray-400 text-xs mt-0.5 leading-relaxed">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div
        className={`w-full px-6 mt-auto mb-10 transition-all duration-700 delay-400 ${
          fadeIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <button
          onClick={handleStart}
          className="w-full font-semibold active:scale-[0.98] transition-transform"
          style={{
            height: '56px',
            minHeight: '56px',
            borderRadius: '16px',
            fontSize: '16px',
            letterSpacing: '0.01em',
            background: 'linear-gradient(135deg, #6366f1 0%, #7c3aed 100%)',
            color: '#FFFFFF',
            boxShadow: '0 4px 14px rgba(99,102,241,0.25)',
            border: 'none',
            cursor: 'pointer',
            display: 'block',
            position: 'relative',
          }}
        >
          <span className="absolute inset-0 flex items-center justify-center gap-2">
            <i className="ri-rocket-line text-lg" />
            开始使用
          </span>
        </button>

        <p
          className="text-center mt-3"
          style={{ fontSize: '12px', color: '#D1D5DB' }}
        >
          继续即表示同意相关服务协议
        </p>
      </div>
    </div>
  );
}
